import { render, staticRenderFns } from "./legendas-forca-trabalho-prospeccao-responsive.vue?vue&type=template&id=440fd678&scoped=true"
import script from "./legendas-forca-trabalho-prospeccao-responsive.vue?vue&type=script&lang=js"
export * from "./legendas-forca-trabalho-prospeccao-responsive.vue?vue&type=script&lang=js"
import style0 from "./legendas-forca-trabalho-prospeccao-responsive.vue?vue&type=style&index=0&id=440fd678&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "440fd678",
  null
  
)

export default component.exports